<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { useEditorStore } from '@/stores/Editor'

const route = useRoute()
const store = useEditorStore()
const companyName = route.params.name as string

const iframeSrc = computed(
  () => `${window.location.origin}/${route.params.id}/${encodeURIComponent(companyName)}`,
)
</script>

<template>
  <div :class="['editor-frame', store.activeDevice]">
    <iframe
      :src="iframeSrc"
      id="editor-page-preview"
      title="Public page preview"
      name="editor-page-preview"
      sandbox="allow-same-origin allow-scripts"
    ></iframe>
  </div>
</template>

<style lang="scss" scoped>
.editor-frame {
  height: calc(100% - 20px);
  margin: 0 auto;

  &.desktop {
    width: 100%;
  }

  &.tablet {
    max-width: 958px;
  }

  &.phone {
    max-width: 450px;
  }
}

iframe {
  border: 0;
  display: block;
  min-width: 100%;
  height: calc(100% - 20px);
  background-color: #eaeaea;
}
</style>
